import { createElement as rc, forwardRef } from 'react';
import useFormControl from '../../hooks/useFormControl';
import { styled, View, Spinner, fromTheme } from 'lib_ui-primitives';
import FormField from './FormField';
import useFormContext from '../../hooks/useFormContext';
import PropTypes from 'prop-types';
import { Text } from 'lib_ui-primitives';

const StyledText = styled(Text)`
    flex-grow: 1;
`;

const StatusLine = styled(View)`
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin: ${fromTheme('viewMargin')};
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: 0px;
`;
const StatusText = styled(Text)`
    flex: 1;
    font-size: ${fromTheme('fontSize')};
`;

const _p = {
    useFormControl
};
export const _private = _p;

const ReadOnlyText = forwardRef(function ReadOnlyText(props, ref) {
    const {
        hNode,
        hNode: {
            id,
            propertyName,
            rows,
            treePosition: { sequence }
        },
        multiline,
        style
    } = props;

    const { title, value } = _p.useFormControl(props);
    const form = useFormContext();
    if (hNode.compact) {
        return rc(StatusLine, { style, role: 'status' },
            form.newRecord?.[hNode.busyProperty] && rc(Spinner, { size: 'small' }),
            rc(StatusText, { ref, id, 'aria-label': title }, value ? String(value) : '')
        );
    }
    const fieldEmpty = value === '';

    // prettier-ignore
    return rc(FormField, { hNode, title, fieldEmpty, style, autoHeight: true },
        rc(StyledText, {
            hNode,
            ref,
            id,
            name: propertyName,
            multiline,
            rows,
            value,
            sequence,
            'aria-label': title
        }, value ? String(value) : '')  // need to ensure value is a string for Text component
    );
});
ReadOnlyText.propTypes = {
    hNode: PropTypes.shape({
        treePosition: PropTypes.shape({
            sequence: PropTypes.number.isRequired
        }).isRequired
    }).isRequired,
    multiline: PropTypes.bool
};

export default ReadOnlyText;
